export default __webpack_public_path__ + "static/media/loading.bcffe8ac.svg";